import React from 'react';

import NavigationArrow from '../../ui/NavigationArrow';

import '../../../scss/earth/ui/NavigationArrowE.scss';

const NavigationArrowE = (props = {}) => {
	return (<NavigationArrow {...props} />);
}

export default NavigationArrowE;